
import { GET_USERS_BY_IDS, LIST_AUTHORS, SEARCH_USERS_AND_GROUPS } from "./gql";
import { LicenseTypeEnum, PermissionEnum, PermissionPermissableTypeEnum, QueryUsersArgs, User } from "../../../cms-glue/gql";
import { CmsUser } from "../../../cms-glue/types";
import { ApolloGQLClient } from "../ApolloGQLClient";
import GQLProjects from "../projects/GQLprojects";
export default class GQLUser
{
	public static gqlUserToCmsUser(user: User): CmsUser
	{
		return {
			id: parseInt(user?.databaseId as string),
			name: user?.name,
			first_name: user?.firstName,
			last_name: user?.lastName,
			email: user?.email,
			username: user?.username,
			permalink: user?.permalink,
			licenses: user?.licenses
		};
	}

	static getAuthorizedUsers = async (projectId?: string) =>
	{
		const project = await GQLProjects.getProjectByID({ databaseId: projectId });
	
		if (!project) 
		{
			throw new Error('Project not found');
		}
	
		const whitelistedUsers = project.resourcePermissions?.filter(
			p => p.permissableType === PermissionPermissableTypeEnum.User && !!p.permissable
		).map(p => p.permissable?.databaseId)
	
		console.info({ project, whitelistedUsers }, 'requested whitelisted authors for the project');
	
		return {
			'whitelisted': whitelistedUsers || []
		};
	}

	static async getUsersByIds(userIds: string[])
	{
		const variables = {
			databaseIds: userIds
		};

		const data = await ApolloGQLClient.query(GET_USERS_BY_IDS, variables, 'request to list users for an organization');

		console.info({
			data
		}, 'response to get users by ids request');

		const users: User[] = data.users?.nodes || [];
		return users;
	}

	static gqlUserToPermission(user: User)
	{
		const licenses = (user.licenses?.nodes || []).map((license) => license?.type);

		if (licenses.length === 0)
		{
			return Error('User has no licenses');
		}

		if (licenses.includes(LicenseTypeEnum.Author) || licenses.includes(LicenseTypeEnum.Admin))
		{
			return PermissionEnum.Manage;
		}
		else if (licenses.includes(LicenseTypeEnum.Reviewer))
		{
			return PermissionEnum.Review;
		}
		else 
		{
			return PermissionEnum.Read;
		}
	}

	static async searchUsersAndGroups(fullText: string | null, withViewers = false)
	{
		const licenseTypes = [LicenseTypeEnum.Admin, LicenseTypeEnum.Author, LicenseTypeEnum.Reviewer];

		if (withViewers) 
		{
			licenseTypes.push(LicenseTypeEnum.Viewer);
		}

		const variables: QueryUsersArgs = {
			fullText,
			licenseTypes
		}

		const data = await ApolloGQLClient.query(SEARCH_USERS_AND_GROUPS, variables, 'request to search users and groups');

		console.info({
			data
		}, 'response o search users and groups');
		
		return {
			'usersAndGroups': data?.viewer?.organization?.usersAndGroups
		};
	}

	static async getAuthors(withViewers = false)
	{
		const licenseTypes = [LicenseTypeEnum.Author, LicenseTypeEnum.Reviewer];

		if (withViewers) 
		{
			licenseTypes.push(LicenseTypeEnum.Viewer);
		}

		const variables: QueryUsersArgs = {
			licenseTypes
		}

		const data = await ApolloGQLClient.query(LIST_AUTHORS, variables, 'request to list users for an organization');

		console.info({
			data
		}, 'response to list users request');

		return data.users.nodes as User[];
	}
}